<div class="hr-video-box">
  <div [hidden]="!video">
    <div #videoPlayer class="skeleton-item skeleton-full"></div>
  </div>
  <video *ngIf="url" width="100%" controls><source [src]="url" /></video>
</div>
